// extracted by mini-css-extract-plugin
module.exports = {"advertisers-page":"advertisers_advertisers-page__2ArqT"};